import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { UserNameAlertTitle, Username } from "../../../../Constants/Constants";
import { UserNameAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";

const UserNameAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      input: "text",
      inputLabel: "Please! Submit Your Username :",
    }).then((result) => {
      result.isConfirmed && Swal.fire({ text: `Your name is : ${result.value}` });
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={UserNameAlertTitle} span={UserNameAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-13" onClick={handleAlert}>
            {Username}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default UserNameAlert;
